import { detentionTypeInfo } from '../../../../components/UI/Organisms/DetentionDescriptionModal/contracts';
import {
  PodTrainingSourceEnum,
  trainingType,
} from '../../../../components/UI/Organisms/PodTraining/contractsPodTraining';
import { TrainingType } from '../../../../components/UI/templates/TripDetailsTemplate/damageTraining/damagetrainingCta';

const urls = {
  fetchOperatorTrips(argArr: Array<string>) {
    return `/odin/v2/operators/consignment?${argArr.join('&')}`;
  },
  fetchOperatorTripsV2(argArr: Array<string>) {
    return `/rest/tesseract/v1/trip?${argArr.join('&')}`;
  },
  fetchTripExpense(demandId: string) {
    return `/odin/operator-app/trip-expenses?demand-id=${demandId}`;
  },
  fetchTripExpenseV2(tripId: string) {
    return `/odin/operator-app/trip-expenses?tripId=${tripId}`;
  },
  fetchTripTracking(demandId: string) {
    return `/rest/tesseract/v1/trip/${demandId}`;
  },
  fetchTripTrackingV2(tripId: string) {
    return `/rest/tesseract/v2/trip/${tripId}`;
  },
  fetchTripPodOtp(tripId: string) {
    return `/rest/tesseract/v2/trip/${tripId}/pod-otp`;
  },
  fetchPaymentHistory(demandId: string) {
    return `/odin/operator-app/trip-transactions?demand-id=${demandId}`;
  },
  fetchPaymentHistoryV2(tripId: string) {
    return `/odin/operator-app/trip-transactions?tripId=${tripId}`;
  },
  fetchTripSummary(demandId: string) {
    return `/odin/operator-app/trip-detail?demand-id=${demandId}`;
  },
  fetchTripSummaryV2(tripId: string) {
    return `/rest/tesseract/v2/trip/trip-state-detail?tripId=${tripId}`;
  },
  fetchStates() {
    return `/odin/v2/active-loads/states`;
  },
  fetchOperatorLoads(payload: any) {
    return `/rest/tesseract/v1/load?state-id=${payload.state[0] && payload.state[0] ? payload.state[0] : ''}`;
  },

  getVechicle() {
    return `/supply/vehicle/app/get-vehicles`;
  },

  // change pathing to tessract for load-response api
  setOpResponse(demandId: any) {
    return `/rest/tesseract/v1/load/${demandId}/consent`;
  },
  callPoc(id: any) {
    return `/odin/v2/${id}/call`;
  },
  fetchLoadDetails(payload: any) {
    return `/odin/v2/active-load/${payload.demandId}`;
  },
  fetchLoadQuoteQuality(demandId: number) {
    return `/rest/tesseract/v1/load/${demandId}/quote-quality`;
  },
  postLoadQuote(demandId: number) {
    return `/rest/tesseract/v1/load/${demandId}/quote`;
  },
  getSearchOptions(action: string) {
    return `/odin/v2/active-loads/search-option?action=${action}`;
  },
  getPlaceholderBannerDetail(action: string) {
    return `/banner?displayPage=${action}`;
  },
  postUploadDocUrl() {
    return `/odin/operator-app/upload-url`;
  },
  postUploadDocUrl2(payload: any) {
    return `rest/tesseract/v1/profile/document/upload-url`;
  },

  getUploadedDocImg(payload: any, typeImg: any) {
    return `/supply/vehicle/app/view-url/${typeImg}/${payload}`;
  },
  getUploadedDocImg2(payload: any, typeImg: any) {
    return `/rest/tesseract/v1/document/view-url/${payload}`;
  },

  fetchPodDetailsApiUrl(demandId: string) {
    return `/odin/operator-app/trip-pod-details?demand-id=${demandId}`;
  },
  fetchPodDetailsApiUrlV2(tripId: string) {
    return `/odin/operator-app/trip-pod-details?tripId=${tripId}`;
  },

  podUpdateDocAPiUrl(demandId: string) {
    return `/odin/operator-app/submit-pod`;
  },
  // getUploadedDocImg(payload: any, typeImg: any) {
  //   return `/supply/vehicle/app/view-url/${typeImg}/${payload}`;
  // },

  searchUnloadingPoint: (payload: any) => {
    return `/odin/v2/map/app/search?text=${payload.searchText}&addressTypes=${payload.addressTypes}`;
  },

  getVehicleAvailModalShowAPiUrle() {
    return `/odin/operator-web/services/info/show-vehicle-availability`;
  },

  postInitiateMembershipPayment(payload: any) {
    return `/odin/v2/operator-subscription`;
  },

  postMembershipPaymentDetails(payload: any) {
    return `/odin/v2/submit-payment`;
  },

  getSurveyQuestionApiUrl() {
    return `/odin/operator-web/services/info/app-config`;
  },

  postSurveyFormApiUrl() {
    return `/odin/operator-web/survey/question-response`;
  },

  postOtpApiUrl() {
    return `/rest/tesseract/v1/trip/otp`;
  },

  postStageOtpApiUrl() {
    return `/rest/tesseract/v1/trip/operator/advance-state`;
  },

  tripAdvanceState() {
    return `/rest/tesseract/v1/trip/operator/advance-state`;
  },

  fetchOperatorProfileGetApiUrle() {
    return `/rest/tesseract/v1/profile`;
  },

  operatorKycUpdateDoc() {
    return `/rest/tesseract/v1/profile/document/update`;
  },

  updateVehicleDataApi(vehicleId: any) {
    return `/rest/tesseract/v1/vehicle`;
  },

  submitPod() {
    return `/rest/tesseract/v1/trip/submit-pod`;
  },
  sendResponseEvent(payload: any) {
    return `/odin/operator-app/trip/feedback-action`;
  },
  vehicleAvailability() {
    return `/rest/tesseract/v1/questionnaire/vehicle-availability`;
  },
  fetchLoadDetailsV2(demandId: number) {
    return `/rest/tesseract/v1/load/${demandId}`;
  },
  feedbackRating() {
    return `/rest/tesseract/v1/profile/rating`;
  },

  getOperatordetails(payload: any) {
    return `/odin/operator-app/v1/profile/tds-declaration`;
  },
  initiateTdsDeclaration(payload: any) {
    return `/odin/operator-app/v1/profile/tds-declaration`;
  },

  appConfigV2() {
    return '/rest/tesseract/v1/config/app';
  },
  fetchOperatorTicketUrl(payload: any) {
    return `/rest/tesseract/v1/ticket?pageNo=${payload.pageNo}&pageSize=${payload.pageSize}`;
  },
  tripRemarks(tripId: number, action: string) {
    return `/rest/tesseract/v2/trip/${tripId}/reasons?action=${action}`;
  },
  slots(tripId: number, location: string) {
    return `/rest/tesseract/v2/trip/${tripId}/slot?location=${location}`;
  },
  updateRemarks(tripId: number) {
    return `/rest/tesseract/v2/trip/${tripId}/slot`;
  },
  fetchOperatorPolicyUrl(payload: any) {
    return `rest/tesseract/v1/policy?type=${payload.policyType}`;
  },
  postOperatorPolicyAcceptUrl() {
    return `rest/tesseract/v1/policy`;
  },
  getSubscribtionCongigUrl() {
    return `/rest/tesseract/v1/config/subscription`;
  },
  getCancelReasonActiveLoad(demandId: any) {
    return `/rest/tesseract/v1/token/${demandId}/cancel-reasons`;
  },
  postCancelReasonActiveLoad(demandId: any) {
    return `/rest/tesseract/v1/token/${demandId}/cancel`;
  },
  fetchTripFilter() {
    return `/rest/tesseract/v1/trip/trip-state-filter`;
  },
  settingsUrl() {
    return `/setting`;
  },

  demandEditurl(id: any) {
    return `/rest/tesseract/v2/trip/${id}/charges`;
  },
  setPanAdhaarLinking: () => '/rest/tesseract/v1/profile/operative',

  ratingTraining(page: any) {
    return `/rest/tesseract/v1/config/rating/training-info?page=${page}`;
  },
  getOperatorInvoiceUrl: (filePath: string) => `rest/tesseract/v1/document/invoice/view-url?filePath=${filePath}`,

  patchOperatorInvoiceUrl: (id: string) => `rest/tesseract/v2/trip/${id}/invoice`,

  uploadUrl: (id: string, file: string) => `rest/tesseract/v2/trip/${id}/invoice/upload-url?file=${file}`,

  fetchWeLangKeyValues: () => `rest/tesseract/v1/config/welang?usedBy=WEB_APP`,

  fetchTrainingContent: (trainingType: trainingType, source: PodTrainingSourceEnum, tripId: string) =>
    `/tesseract/v2/trip/${tripId}/training?type=${trainingType}&source=${source}`,

  fetchTrainingContentV2: (trainingType: TrainingType, tripId: string) =>
    `/rest/tesseract/v2/trip/${tripId}/training?type=${trainingType}`,

  submitCompleteTraining: (type: string, tripId?: string) =>
    `/rest/tesseract/v1/config/training/status?type=${type}&id=${tripId}`,

  postAcknowledgementUrl: () => `/rest/tesseract/v1/trip/widget-acknowledgement`,

  fetchDetentionContent: (tripId: string, type: detentionTypeInfo) =>
    `/rest/tesseract/v2/trip/${tripId}/policy/expenses?type=${type}`,
  odvtRateCardStatus: () => `/rest/tesseract/v1/operator/odvtRateCardStatus`,
  getRemarks: (tripId: string, actionType: string) => `/rest/tesseract/v1/trip/${tripId}/delay?type=${actionType}`,
  updateDelayRemarks: (tripId: string) => `/rest/tesseract/v1/trip/${tripId}/delay`,
  postReasonSubmit() {
    return `/rest/tesseract/v1/trip/operator/state-change-alert`;
  },

  fetchAdvanceStateView() {
    return `/rest/tesseract/v1/trip/operator/advance-state-view`;
  },

  updateSessionVariablesUrl: () => `/rest/tesseract/v1/chats/session/update-variables`,
};

export default urls;
